import Reveal from "@/components/landing/Reveal";

export default function HowItWorksSection({ block }) {
  const steps = block?.steps || [];
  return (
    <section id="como-funciona" className="section-cream on-light py-24 md:py-32 relative overflow-hidden">
      <div className="absolute inset-0 dot-grid opacity-30 pointer-events-none" style={{ backgroundImage: "radial-gradient(rgba(10,10,11,0.08) 1px, transparent 1px)" }} />
      <div className="max-w-[1300px] mx-auto px-6 lg:px-10 relative">
        <div className="text-center mb-14">
          <Reveal><span className="eyebrow">Cómo funciona</span></Reveal>
          <Reveal delay={120}>
            <h2 className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl text-[#0A0A0B]">
              {(() => {
                const raw = block?.title || "Conoce primero. Decide <em>después</em>.";
                const parts = raw.split(/(<em>[^<]*<\/em>)/g);
                return parts.map((p, i) => {
                  const m = p.match(/^<em>([^<]*)<\/em>$/);
                  if (m) return <span key={i} className="accent">{m[1]}</span>;
                  return <span key={i}>{p}</span>;
                });
              })()}
            </h2>
          </Reveal>
        </div>
        <div className="grid md:grid-cols-4 gap-4 relative">
          <div className="hidden md:block absolute top-6 left-[12.5%] right-[12.5%] h-px bg-gradient-to-r from-transparent via-[#FFBF57] to-transparent" />
          {steps.map((s, i) => (
            <Reveal key={i} delay={i * 100}>
              <div className="card-light p-6 h-full relative">
                <div className="w-12 h-12 rounded-full bg-[#F4F4F5] border-2 border-[#FFBF57] text-[#0A0A0A] text-lg num-mono font-bold flex items-center justify-center mb-5 relative z-10 shadow-[0_0_24px_rgba(255,191,87,0.35)]">
                  {s.n || i + 1}
                </div>
                <div className="font-display text-lg text-[#0A0A0B] mb-2">{s.title}</div>
                <p className="text-sm text-[#3A3A42] leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
